import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { EN_LOCAL } from '@/helpers/locale';
let TranslateMixin = class TranslateMixin extends Vue {
    get timeFormat() {
        return this.$i18n.locale === EN_LOCAL ? `hh:mm a` : `HH:mm`;
    }
    get labelKey() {
        return this.$i18n.locale === EN_LOCAL ? `en_name` : `fr_name`;
    }
};
TranslateMixin = __decorate([
    Component
], TranslateMixin);
export default TranslateMixin;
;
